module.exports = __webpack_public_path__ + "img/CV.06416a19.svg";